module.exports = __webpack_public_path__ + "static/media/Floating_Tube_Rack.0cba2889.svg";